"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SupportingCreativeFormatFastStartItem {
    constructor({ enabled }) {
        this.toJSON = () => ({
            enabled: this.enabled,
        });
        this.enabled = enabled;
    }
}
SupportingCreativeFormatFastStartItem.fromJSON = (json) => {
    const { enabled } = Object.assign({}, json);
    if (typeof enabled !== 'boolean')
        throw new Error('.enabled must be a boolean');
    return new SupportingCreativeFormatFastStartItem({
        enabled,
    });
};
exports.default = SupportingCreativeFormatFastStartItem;
